export default {
  staticCanvas: 'static-canvas',
  canvas: 'canvas',
  bgCanvas: 'bg-canvas',
  loadingSpinner: 'widget-loading',
  rootLayout: 'widget-root-layout',
  root: 'root',
};
